import { sum } from 'lodash-es'
import AddOn from './AddOn'
import BaseItem from './BaseItem'

export default class OrderItem extends BaseItem {

	/** @type number */ quantity
	/** @type string */ menubuddy
	/** @type string */ special_instructions
	/** @type number */ line_total //TODO maybe we should start using this on the Order Details instead?
	/** @type number */ line_total_with_add_ons
	/** @type {AddOn[]|Model[]} */ add_ons
	/** If set, this entry is actually an adjustment to the Item referenced by this ID
	 * @type ?int */ adjusted_order_item_id
	/** Is this item actually an adjustment to another order item?
	 * @type boolean */ isSubAdjustment

	constructor({ add_ons, menubuddy_name, ...attrs }) {
		super(attrs)

		this.menubuddy       = (menubuddy_name && menubuddy_name.toLowerCase() != 'me')? menubuddy_name : null
		this.add_ons         = AddOn.map(add_ons.filter(add_on => !add_on.hide_on_order_sheet))
		this.isSubAdjustment = !!this.adjusted_order_item_id
	}

	/**
	 * Calculates the total amount for a given list of ordered items (based on {@link OrderItem.line_total_with_add_ons}).
	 * @param items {OrderItem[]}
	 * @returns {number}
	 */
	static totalForList(items) {
		return items.map(i => i.line_total_with_add_ons)|>sum(#)
	}

}
